import React from 'react';
import { makeStyles } from '@mui/styles';
import SMCIcon from '../../Simple/SMCIcon';
import RowLayout from '../../Layouts/RowLayout';

function SMCMainFooterErrorBoundary({
    resetErrorBoundary
}) {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <div className={classes.errorMaskRoot}>
                <div className={classes.errorContainer}>
                    <div className={classes.errorBox}>
                        <RowLayout center spacing="8px">
                            <SMCIcon icon="refresh" onClick={resetErrorBoundary} />
                            Error...
                        </RowLayout>
                    </div>
                </div>
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        height: '100%',
        width: '100%',
        background: '#171F2C',
        color: '#E8F1FF',
        fontSize: '13px',
        lineHeight: '23px',
        paddingTop: '1px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    },
    errorMaskRoot: {
        width: '100%',
        position: 'absolute',
        textAlign: 'center',
        background: '#f7f7f780',
        zIndex: 999
    },
    errorContainer: {
        textAlign: 'center',
        display: 'inline-block'
    },
    errorBox: {
        width: '100px',
        backgroundColor: '#e0e4e8',
        color: '#333'
    }
});

export default SMCMainFooterErrorBoundary;